import {Injectable, Injector} from "@angular/core";
import {CrudService} from "@mango/core";
import {HttpClient} from "@angular/common/http";
import {School} from "./school";

@Injectable()
export class SchoolService extends CrudService<School> {

  constructor(injector: Injector, protected http: HttpClient) {
    super(School, injector);
  }
}
